import PanelTemplate from "components/shared/profile/panel";
import React from "react";
import { getOrderNotificationOption, setOrderNotificationOption } from "sources/profile/user";
import { config, initialState } from "./config";

class OrderNotifications extends PanelTemplate {
    state = {
        data: {},
        isValid: true,
    };

    componentDidMount() {
        getOrderNotificationOption().then(({ sendOrderNotifications }) =>
            this.setState({
                data: { isEnabled: sendOrderNotifications },
                initial: { isEnabled: sendOrderNotifications },
            }),
        );
    }

    componentDidUpdate() {
        return undefined;
    }

    update = () => {
        const { data } = this.state;
        if (!this.isValidForm(data)) {
            return this.setState({ isValid: false });
        }
        return setOrderNotificationOption(data).then((res) => {
            if (!res) {
                this.setState({ isValid: false });
            }
            this.setState({ shouldUpdate: false });
        });
    };

    setValue = ({ value, name }) => {
        const data = { ...this.state.data, [name]: value };
        const shouldUpdate = this.compareStateAndProps(this.state.initial, data);
        const isValid = this.isValidForm(data);
        this.setState({ data, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    renderBody = () => {
        const { isEnabled } = this.props.config;
        return (
            <div className="row">
                <div className="col-sm-4">
                    <h5>Уведомления о подходящих заказах</h5>
                </div>
                <div className="col-sm-8">{this.renderCheckbox(isEnabled)}</div>
            </div>
        );
    };
}

const ConfiguredPanel = (props) => <OrderNotifications {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
